import React, { Component } from 'react';
import { connect } from 'react-redux';

import pickupOrderRemote from '../../../api/pickupOrderRemote';

import { receiveError } from '../../../store/actions/notificationAction';
import ResponseError from '../../../models/ResponseError';
import OrderModel from '../../../models/PickupOrderFwd';
import ApiResponse from '../../../models/ApiResponse';

import WhsOrderSearch from './whsOrderSearch';
import WhsOrderTable from './WhsOrderTable';
import OrderAttachmentsContainer from '../../orderAttachments/OrderAttachmentsContainer';

import commonStyles from '../../common/common.module.css';

interface WhsOrderAwbSearchContainerProps {
  receiveError: Function;
};
  
interface WhsOrderAwbSearchContainerState {
  keyword: string;
  errorKeyword: boolean;
  orderList: Array<OrderModel>;
  isOrderAttachmentsDialogOpen: boolean;
  attachmentOrderNumber: OrderModel;
  orderNumber: string;
};

class WhsOrderAwbSearchContainer extends Component<WhsOrderAwbSearchContainerProps, WhsOrderAwbSearchContainerState> {

  state = {
    keyword: '',
    errorKeyword: false,
    orderList: [],
    isOrderAttachmentsDialogOpen: false,
    attachmentOrderNumber: {} as OrderModel,
    orderNumber: ''
  }

  handleChangeKeyword = (event: any): void => {

    const value: string = event.target.value;
    const keyword: string = value.toUpperCase();

    this.setState({ keyword });
  };


  search = (): void => {

    if (!this.state.keyword ||  this.state.keyword.length < 3 ) {
      return this.setState({ errorKeyword: true }); 
    }
    this.doGetOrdersRequest(this.state.keyword );
    this.setState({ errorKeyword: false });
  };

  closeOrderAttachments = (): void => {

    this.setState({ isOrderAttachmentsDialogOpen: false });
  };

  openAttachments = (order: OrderModel): void => {

    this.setState({ isOrderAttachmentsDialogOpen: true, attachmentOrderNumber: order });
  };

  doGetOrdersRequest = ( keyword: string): void => {

    pickupOrderRemote.getOrdersWhsSearch( keyword ).then((resp: ApiResponse<Array<OrderModel>>) => {
    
      const orderList: Array<OrderModel> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (orderList) {
        this.setState({ orderList });
      };

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  render() {

    return (
      <div>
        <div className={ `${ commonStyles.searchWrapperOuter } ${ commonStyles.noheadSearch }`}>
          <WhsOrderSearch 
            keyword={ this.state.keyword }
            errorKeyword={ this.state.errorKeyword }
            handleChangeKeyword={ this.handleChangeKeyword }
            search={ this.search }
          />
        </div>
        <WhsOrderTable 
          orders={ this.state.orderList }
          openAttachments={ this.openAttachments }
        />
         { this.state.isOrderAttachmentsDialogOpen && 
            <OrderAttachmentsContainer
              orderId={ this.state.attachmentOrderNumber.id }
              number={ this.state.attachmentOrderNumber.number }
              process={ "export" }
              closeAttachments={ this.closeOrderAttachments }
              refreshAwbs={ true }
              type={ 'orders' }
            />
          }
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
};
  
export default connect(null, mapDispatchToProps)(WhsOrderAwbSearchContainer);
